import React from 'react';
import { motion } from 'framer-motion';
import { Check, MessageCircle, Stethoscope, Store } from 'lucide-react';
import { WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
const configurations = [{
  title: 'Página de Servicios',
  ideal: ['Doctores', 'Odontólogos', 'Abogados', 'Consultores', 'Técnicos', 'Clínicas', 'Empresas de servicios'],
  includes: ['Presentación profesional', 'Información de servicios', 'Perfil del profesional o empresa', 'Ubicación y horarios', 'Reseña o testimonio', 'Preguntas frecuentes', 'Botón directo a WhatsApp', 'Formulario opcional de contacto', 'Redes sociales'],
  icon: Stethoscope,
  message: WHATSAPP_MESSAGES.professional,
  event: 'whatsapp_professional_click' as const
}, {
  title: 'Catálogo con pedidos por WhatsApp',
  ideal: ['Restaurantes', 'Cafeterías', 'Tiendas', 'Emprendimientos', 'Comercios locales', 'Negocios con catálogo'],
  includes: ['Productos con foto, nombre, descripción y precio', 'Categorías', 'Carrito de compras', 'Resumen del pedido', 'Envío del pedido directamente a WhatsApp', 'Productos disponibles o agotados', 'Ubicación y horarios', 'Redes sociales', 'Información del negocio'],
  icon: Store,
  message: WHATSAPP_MESSAGES.catalog,
  event: 'whatsapp_catalog_click' as const
}];
export function ProductConfigurationsSection() {
  return <section className="bg-[#050511] py-24" aria-labelledby="configuraciones-title" data-id="element-1276">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1277">
        <div className="mb-14 text-center" data-id="element-1278">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-1279">
            Elegí la versión que necesita tu negocio
          </p>
          <h2 id="configuraciones-title" className="text-3xl font-bold text-white md:text-5xl" data-id="element-1280">
            Una página profesional.{' '}
            <span className="text-gradient-cosmic" data-id="element-1281">
              Dos formas de utilizarla.
            </span>
          </h2>
        </div>

        <div className="grid gap-6 lg:grid-cols-2" data-id="element-1282">
          {configurations.map((configuration, index) => {
          const Icon = configuration.icon;
          return <motion.article key={configuration.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.12
          }} className="flex flex-col rounded-2xl border border-white/10 bg-[#101022] p-7 md:p-9" data-id="element-1283">
                <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl bg-[#a738f4]/15" data-id="element-1284">
                  <Icon className="h-6 w-6 text-[#d58aff]" data-id="element-1285" />
                </div>
                <h3 className="text-2xl font-bold text-white" data-id="element-1286">
                  {configuration.title}
                </h3>
                <p className="mt-5 text-sm font-semibold text-[#a9a9ba]" data-id="element-1287">
                  Ideal para:
                </p>
                <div className="mt-3 flex flex-wrap gap-2" data-id="element-1288">
                  {configuration.ideal.map(item => <span key={item} className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-[#d7d7e1]" data-id="element-1289">
                      {item}
                    </span>)}
                </div>
                <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-1290">
                  {configuration.includes.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-relaxed text-[#c9c9d6]" data-id="element-1291">
                      <Check className="mt-0.5 h-4 w-4 flex-none text-[#20d6e8]" data-id="element-1292" />
                      {item}
                    </li>)}
                </ul>
                <a href={createWhatsAppUrl(configuration.message)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent(configuration.event, {
              cta_location: 'product_configuration',
              selected_product: configuration.title
            })} className="mt-8 inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-[#25d366]/40 bg-[#25d366]/10 px-5 py-3 font-semibold text-[#d8ffe6] transition-colors hover:bg-[#25d366]/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#25d366]" data-id="element-1293">
                  <MessageCircle className="h-5 w-5 text-[#25d366]" data-id="element-1294" />
                  Quiero esta versión
                </a>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}